module.exports = __webpack_public_path__ + "static/img/banner-bg-h5.9456970.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/dec/banner-bg-h5.png
// module id = Wf8y
// module chunks = 34